import { render, staticRenderFns } from "./feedbackInfo.vue?vue&type=template&id=75155bdc&scoped=true&"
import script from "./feedbackInfo.vue?vue&type=script&lang=js&"
export * from "./feedbackInfo.vue?vue&type=script&lang=js&"
import style0 from "./feedbackInfo.vue?vue&type=style&index=0&id=75155bdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75155bdc",
  null
  
)

export default component.exports